module.exports = __webpack_public_path__ + "img/7.0db8b963.jpg";